/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetUserBaseResponse
 */
export interface GetUserBaseResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetUserBaseResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetUserBaseResponse
     */
    firstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBaseResponse
     */
    lastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserBaseResponse
     */
    email: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetUserBaseResponse
     */
    customerId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserBaseResponse
     */
    roles: Array<string> | null;
}

/**
 * Check if a given object implements the GetUserBaseResponse interface.
 */
export function instanceOfGetUserBaseResponse(value: object): value is GetUserBaseResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function GetUserBaseResponseFromJSON(json: any): GetUserBaseResponse {
    return GetUserBaseResponseFromJSONTyped(json, false);
}

export function GetUserBaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserBaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'customerId': ActorActivityRecordActorUserIdFromJSON(json['customerId']),
        'roles': json['roles'] == null ? null : json['roles'],
    };
}

export function GetUserBaseResponseToJSON(json: any): GetUserBaseResponse {
    return GetUserBaseResponseToJSONTyped(json, false);
}

export function GetUserBaseResponseToJSONTyped(value?: GetUserBaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'customerId': ActorActivityRecordActorUserIdToJSON(value['customerId']),
        'roles': value['roles'],
    };
}

